import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConstant } from "src/app/app.constant";
import { map } from "rxjs/operators";

@Injectable()
export class LoginService {
    apiUrl: string;
    whatsAppURL : string
    constructor(private httpClient: HttpClient,
        private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl()
        this.whatsAppURL = this.appConstant.getWhatsAppURL()
    }
    checkEmail(email) {
        const params = {
            Email: email
        }
        return this.httpClient.post(`${this.apiUrl}/checkEmail`, params).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    authenticate(user) {
        return this.httpClient.post(`${this.apiUrl}/login`, user).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    resetPasswordUser(password) {
        return this.httpClient.post(`${this.apiUrl}/changePassword`, password).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    resetPasswordBySuperAdmin(password) {
        return this.httpClient.post(`${this.apiUrl}/resetPasswordBySuperAdmin`, password).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    resetPassword(password: string) {
        return this.httpClient.post(`${this.apiUrl}/resetPasswordAfterFirstLogin`, password).pipe(
            map((response: any) => {
                return response as any;
            })
        )
    }
    forgotPassword(UserName: string) {
        let params = {
            Username: UserName
        }
        return this.httpClient.post(`${this.apiUrl}/sendVerificationCode`, params).pipe(map(data => data as any));
    }
    changePassword(password: string) {
        return this.httpClient.post(`${this.apiUrl}/ResetPassword`, password).pipe(map(data => data as any));
    }

    sendVerificationCode(UserName: string) {
        let params = {
            Username: UserName
        }
        return this.httpClient.post(`${this.apiUrl}/sendVerificationCode`, params).pipe(map(data => data as any));
    }
    verifyVerificationCode(userData) {
        return this.httpClient.post(`${this.apiUrl}/verifyVerificationCode`, userData).pipe(map(data => data as any));
    }
    createWhatsAppWebClient(Id) {
        return this.httpClient.get(`${this.whatsAppURL}/createWhatsAppWebClient/` + Id,{
            headers: {
                eduwityapikey : 'hIpqImIwtvTejWRriyQXJUsWvssdrKKBafHvpNjfWbRAecxxUK'
            }
        }).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
}
